module.exports = __webpack_public_path__ + "img/excel.1cd8ce10.svg";